(function ($, njm) {
    'use strict';

    njm.views.hero = Backbone.View.extend({

        events: {
            'click .selected': 'openSelect',
            'click #selectState a': 'selectState',
            'click #selectProduct a': 'selectProduct',
            'click #gotoQuote': 'navigate'
            //'click' : 'hideDropdown'
        },

        /***
         * Initialize
         */
        initialize: function () {
            this.$state = $('#selectState .selected');
            this.$product = $('#selectProduct .selected');
            this.$button = $('#gotoQuote');
            this.$video = this.$('video');
            this.$mediaImg = this.$('.media img');
            this.$geoState = this.$('input[name=geostate]');

            this.initialProductOption = $('#selectProduct .selected').text();

            this.data = window.quoteApps;
            this.selected = {
                stateIndex: 0,
                products: [],
                productIndex: 0,
                device: 'desktop'
            };

            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                this.selected.device = 'mobile';
            }

            this.$product.parent().addClass('disabled');
            this.$button.addClass('disabled');

            if ($('#selectState a.active').length) {
                this.setState($('#selectState a.active').text());
                this.loadProducts();
            }

            if (this.$geoState.val() !== '') {
                this.setState(this.$geoState.val());
                this.loadGeoBasedProducts();
            }

            if (this.$video.length) {
                objectFitVideos(this.$video[0]);
                this.replaceVideoWithImg();
            }
            $('body').click(this.hideDropdown.bind(this));
        },

        /**
         * Replace Video With Image when AutoPlay is not supported
         */
        replaceVideoWithImg: function () {
            if (/iP(ad|od|hone)/i.test(window.navigator.userAgent)) {
                this.$video.hide();
                this.$('object-fit').hide();
                this.$mediaImg.show();
            }
        },

        /**
         * Open custom selects
         */
        openSelect: function (e) {
            var $select = $(e.currentTarget).parent();

            if (!$select.hasClass('disabled')) {
                if ($select[0].id === "selectState") {
                    $('#selectProduct ul').hide();
                }

                $(e.currentTarget)
                    .parent().toggleClass('open')
                    .find('ul').slideToggle(200);
            }
        },

        /**
         * Select  State
         */
        selectState: function (e) {
            e.preventDefault();
            var $selected = $(e.currentTarget);

            this.setState($selected.text());

            this.$button.addClass('disabled');
            $('#selectProduct span').text('Select Product');
            $('#selectProduct ul').empty();
            $selected
                .addClass('active')
                .parent().siblings().children('a').removeClass('active')
                .parents('ul').slideToggle(200)
                .parent().toggleClass('open');
            $('#selectProduct ul').hide();
            this.loadProducts();
        },

        /**
         * Set State
         * @param {string} state
         */
        setState: function (state) {
            this.$state.text(state);
            this.$button.data('layerState', state);
        },

        /**
         * Select  Product
         */
        selectProduct: function (e) {
            e.preventDefault();
            var $selected = $(e.currentTarget);

            this.$product.text($selected.text());

            $selected
                .addClass('active')
                .parent().siblings().children('a').removeClass('active')
                .parents('ul').slideToggle(200)
                .parent().toggleClass('open');

            this.$button.data('layerProduct', $selected.text());
            $('#selectProduct ul').hide();
            this.loadUrl();
        },

        /**
        * Load Products
        */
        loadProducts: function () {
            var $list = $('#selectProduct ul');

            this.selected.stateIndex = $('#selectState a').index($('#selectState a.active')[0]);
            this.selected.products = this.data[this.selected.stateIndex].products;

            $list.empty();

            $(this.selected.products).each(function (index, item) {
                $list.append('<li><a href="#">' + item.name + '</a></li>');
            });

            this.$product.parent().removeClass('disabled');
        },
        findGeoIndex: function (stateName) {
            var toReturn;
            $.each($('#selectState a'), function (key, value) {
                if (value.text === stateName) {
                    toReturn = key;
                    return false;
                }
            });

            return toReturn;
        },
        loadGeoBasedProducts: function () {
            var $list = $('#selectProduct ul');
            if (this.$geoState.val() !== '') {
                this.selected.stateIndex = this.findGeoIndex(this.$geoState.val());
                this.selected.products = this.data[this.selected.stateIndex].products;

                $list.empty();

                $(this.selected.products).each(function (index, item) {
                    $list.append('<li><a href="#">' + item.name + '</a></li>');
                });

                this.$product.parent().removeClass('disabled');
            }
        },
        /**
        * Load URL for button
        */
        loadUrl: function () {
            var queryString = window.location.search;
            var url = '';
            var target = '';
            this.selected.productIndex = $('#selectProduct a').index($('#selectProduct a.active')[0]);
            url = this.selected.products[this.selected.productIndex].desktop;
            target = this.selected.products[this.selected.productIndex].desktopTarget;

            if (this.selected.device === 'mobile') {
                url = this.selected.products[this.selected.productIndex].mobile;
                target = this.selected.products[this.selected.productIndex].mobileTarget;
            }

            this.$button
                .attr({ 'href': url + queryString, 'target': target })
                .removeClass('disabled');
        },

        hideDropdown: function (e, target) {
            if (!$(e.target).closest('#selectState').length) {
                $('#selectState').removeClass('open').find('ul').slideUp(200);
            }
            if (!$(e.target).closest('#selectProduct').length) {
                $('#selectProduct').removeClass('open').find('ul').slideUp(200);
            }
        },

        /**
        * Button click 
        */
        navigate: function (e) {
            if ($(e.currentTarget).hasClass('disabled')) {
                e.preventDefault();
            }
        }
    });
})(jQuery, njm);
